// src/lib/UiNotification.js

/* global Office, console */

/**
 * Shows a notification dialog.
 * @param {string} message - Message to display.
 * @param {string} [type="info"] - Type: "info", "warning", "error".
 */
function showNotification(message, type = "info") {
  const dialogContent = `<div style="padding:20px;font-family:Segoe UI;">${message}</div>`;
  Office.context.ui.displayDialogAsync(
    `data:text/html,${encodeURIComponent(dialogContent)}`,
    { height: 30, width: 40 },
    (result) => {
      if (result.status !== Office.AsyncResultStatus.Succeeded) {
        console.error("Notification dialog failed:", result.error);
      }
    }
  );
}

/**
 * Updates the ribbon mic icon.
 * @param {boolean} isRecording - True if recording.
 */
function updateRibbonMic(isRecording) {
  const iconUrl = isRecording
    ? "https://i.imgur.com/mic-recording.png" // Replace with your actual URLs
    : "https://i.imgur.com/mic-idle.png";

  Office.ribbon.requestUpdate({
    tabs: [{
      id: "TabHome",
      groups: [{
        id: "DoccyGroup",
        controls: [{
          id: "StartRecordingToggle", // Match your manifest ID
          image: { url: iconUrl }
        }]
      }]
    }]
  }).catch((err) => console.warn("Ribbon update failed:", err));
}

// Export functions
export {
  showNotification,
  updateRibbonMic
};